<template functional>
  <div id="loader" class="loader">
    <div class="loader__block"></div>
    <div class="loader__block"></div>
    <div class="loader__block"></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
$background: rgba(0, 0, 0, 0.5);
$block-background: var(--universal-color-white);

.loader {
  position: fixed;
  bottom: -200px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100000;
  border-radius: 15px;
  height: 100px;
  width: 210px;
  background: $background;
  padding: 20px 30px;
  transition: 0.2s ease-in-out;
  display: none;

  &--visible {
    bottom: 30px;
    display: block;
  }

  &__block {
    background: $block-background;
    height: 60px;
    width: 30px;
    margin: 0 5px;
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    animation: loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;

    &:nth-child(1) {
      height: 20px;
      left: 30px;
      animation-delay: -0.24s;
    }

    &:nth-child(2) {
      left: 90px;
      animation-delay: -0.12s;
    }

    &:nth-child(3) {
      height: 20px;
      left: 150px;
      animation-delay: 0;
    }
  }

  @keyframes loader {
    0% {
      height: 60px;
    }

    50%,
    100% {
      height: 20px;
    }
  }
}
</style>
